export class Name {
    public first: string;
    public last: string;
    public unknown: boolean;
}
